import React, {FC, useEffect, useRef, useState} from "react";
import {Modal} from "antd";
import closeIcon from "../../../assets/icons/close.svg";
import ToggleSwitch from "../../../shared/components/ToggleSwitch";
import UploadLogo from "../../../shared/components/UploadLogo";
import {Formik, Form,Field} from "formik";
import ButtonComponent from "../../../shared/components/ButtonComponent";
import InputField from "../../../shared/components/InputField";
import {serialize} from "serializr";
import {convertJSONToFormData} from "../../../shared/utils/converJsonToFormData";
import DropdownField from "../../../shared/components/DropdownField";
import CommonService from "../../../services/CommonService/common.service";
import {InternalUserModel} from "../../../models/InternalUserModel/internalUser.model";
import InternalUserService from "../../../services/InternalUserService/internalUser.service";
import { InternalUsersValidationSchema } from "./internalUsersValidation";

interface InternalUserFormProps{
    title: string;
    visible: boolean;
    setVisible: Function;
    data?:any;
    refreshList:Function;
    currentPageNumber:number;
}

const InternalUserForm:FC<InternalUserFormProps> = (props) => {

    const {title, visible, setVisible, data, refreshList, currentPageNumber} = props;

    const formRef = useRef<any>();

    useEffect(()=>{
        CommonService.fetchMeta('roles',
            (roles:any)=>{
                setRoleOptions(roles)
            },
            ()=>{},
            ()=>{},
        ).then()
    },[])

    useEffect(()=>{
        setInitialValues({
            isActive: data?.isActive ? data.isActive : false,
            displayPicture: null,
            firstName: data?.firstName || null,
            lastName: data?.lastName || null,
            email: data?.email || null,
            phoneNumber: data?.phoneNumber?.substr(3) || null,
            roleId: data?.role?.id,
            password: null,
            confirmPassword: null,
        })
    },[data])

    const [buttonLoading,setButtonLoading] = useState<boolean>(false);
    const [initialValues,setInitialValues] = useState<any>({});
    const [roleOptions,setRoleOptions] = useState<any>([])

    const handleClose = () => {
        setVisible(false);
        formRef.current.resetForm(initialValues);
    }

    const handleSubmit = (values:any) => {
        setButtonLoading(true)
        if(values?.phoneNumber) values.phoneNumber = '+91'+values.phoneNumber
        let internalUserData = serialize(InternalUserModel,values);

        if(values?.displayPicture) internalUserData.display_picture = values.displayPicture
        if(!values?.password) delete internalUserData.password

        let jsonData = {admin: internalUserData}
        let internalUserFormData = convertJSONToFormData(jsonData)

        if(!data){
            InternalUserService.createInternalUser(internalUserFormData,
                ()=>{
                    refreshList(currentPageNumber)
                    setVisible(false)
                    formRef.current.resetForm(initialValues)
                },
                ()=>{},
                ()=>{
                    setButtonLoading(false)
                },
            ).then()
        }else{
            InternalUserService.updateInternalUser(data?.id,internalUserFormData,
                ()=>{
                    refreshList(currentPageNumber)
                    setVisible(false)
                    formRef.current.resetForm(initialValues)
                },
                ()=>{},
                ()=>{
                    setButtonLoading(false)
                },
            ).then()
        }
    }

    return(
        <Modal title={null}
               centered
               visible={visible}
               onCancel={handleClose}
               footer={null}
               className='board-form__modal tutor-form__modal'
               closeIcon={<img src={closeIcon} alt=''/>}
        >
            <Formik initialValues={initialValues}
                    onSubmit={handleSubmit}
                    enableReinitialize
                    innerRef={formRef}
                    validationSchema={InternalUsersValidationSchema}
            >{({setFieldValue,values,resetForm})=> {
                return(
                    <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                        <div className='board-form__header'>
                            <div className='board-form__title'>{title}</div>
                            <div className='board-form__toggle'>
                                <Field name="isActive" as='switch'>
                                    <ToggleSwitch checked={values.isActive}
                                                  handleChange={() => {
                                                      setFieldValue('isActive', !values.isActive)
                                                  }}
                                    />
                                </Field>
                            </div>
                        </div>

                        <Field name="displayPicture" as='file-upload'>
                            <UploadLogo logoUrl={values?.displayPicture ?
                                                values?.displayPicture : data?.displayPictureUrl}
                                        setFile={setFieldValue}
                                        uploadText='Upload photo'
                            />
                        </Field>

                        <div className="board-form__input">
                            <div className='board-form__label'>First Name</div>
                            <InputField type="text" name="firstName" placeholder="Type first name"/>
                        </div>

                        <div className="board-form__input">
                            <div className='board-form__label'>Last Name</div>
                            <InputField type="text" name="lastName" placeholder="Type last name"/>
                        </div>

                        <div className="board-form__input">
                            <div className='board-form__label'>Email</div>
                            <InputField type="text" name="email" placeholder="Type email address"/>
                        </div>

                        <div className="board-form__input">
                            <div className='board-form__label'>Phone</div>
                            <InputField type="text" name="phoneNumber" placeholder="Type phone number" prefix={"+91"}/>
                        </div>

                        <div className="board-form__input">
                            <div className='board-form__label'>Role</div>
                            <DropdownField name='roleId'
                                           placeholder='Select role'
                                           options={roleOptions}
                                           showSearch={false}
                                           value={values.roleId}
                                           onChange={(value:any)=>setFieldValue('roleId',value)}
                                           optionFilterProp='label'
                            />
                        </div>

                        <div className="board-form__input">
                            <div className='board-form__label'>Password</div>
                            <InputField type="password" name="password" placeholder="Password"/>
                        </div>

                        <div className="board-form__input">
                            <div className='board-form__label'>Confirm Password</div>
                            <InputField type="password" name="confirmPassword" placeholder="Confirm password"/>
                        </div>

                        <div className='board-form__action'>
                            <div className='board-form__button' onClick={() => {
                                handleClose();
                                resetForm({})
                            }}>
                                <ButtonComponent buttonContent='Cancel'
                                                 type='text'
                                />
                            </div>
                            <div className='board-form__button'>
                                <ButtonComponent buttonContent={data ? 'Update' : 'Create'}
                                                 type='primary'
                                                 htmlType='submit'
                                                 loading={buttonLoading}
                                />
                            </div>
                        </div>
                    </Form>
                )
            }}
            </Formik>
        </Modal>
    )
}

export default InternalUserForm;
